export const scriptsConfig = {
    getTidioUrl: (id: string | undefined) => (id ? `//code.tidio.co/${id}.js` : undefined),
};
